var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty tc"},[_c('img',{attrs:{"src":require("@/assets/img/empty.png"),"alt":""}}),_c('p',{staticClass:"desc"},[_vm._t("title",function(){return [_vm._v("暂无查询信息~")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }